// extracted by mini-css-extract-plugin
export default {"icon":"Volume_icon__VggJq"};